import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';

import View from './View';
import Data from './Data';

const Edit = (props) => {
  const { data, selected } = props;

  return (
    <>
      <View {...props} data={data} isEditMode />

      <SidebarPortal selected={selected}>
        <Data {...props} />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
